import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

// import { validateLogin } from '@utils';

function AuthRoute(props) {
  const { path, exact, render, ...rest } = props;

  // if (validateLogin()) {
  return <Route path={path} exact={exact} render={render} {...rest} />;
  //   }
  //   return (
  //     <Redirect
  //       to={{
  //         pathname: '/login',
  //         state: {
  //           from: window.location.pathname,
  //         },
  //       }}
  //     />
  //   );
}

AuthRoute.defaultProps = {
  exact: false,
  render: null,
};

AuthRoute.propTypes = {
  exact: PropTypes.bool,
  path: PropTypes.string.isRequired,
  render: PropTypes.func,
};

export default AuthRoute;
